<template>
    <div class="bar-chart" :singleBar="singleBar"  :class="{upon_bars : !singleBar}" :style="{background: colors.theme == 'dark' ? '#0c121e' : '#f0f0f0'}">
        <svg :height="height">
            <rect width="100%" height="100%" :fill="color" stroke-width="3" stroke="none" />
        </svg>
    </div>
</template>

<script>
export default {
    props:['color', 'value', 'singleBar', 'primary'],
    name: 'bar-chart',
    data: () => ({
        height: '',
        colors: {}
    }),

    created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));
        var windowWidth = window.innerWidth
        var windowHeight = window.innerHeight
        // console.log('Height: ', windowHeight)
        
        if(this.singleBar){
            // windowWidth <= 500 ? this.height = (this.value * 1.5) * 10 : this.height = (this.value * 2) * 10
            if(windowWidth <= 320){
                this.height = (this.value) * 10
                return
            }
            if(windowHeight <= 565 && windowWidth >= 360){
                this.height = (this.value * 1.5) * 10 - 15
                return
            }
            if(windowWidth <= 500 && windowWidth > 320){
                this.height = (this.value * 1.5) * 10
                return
            }
            if(windowWidth > 500){
                this.height = (this.value * 1.5) * 10
                return
            }  
        }

        let you = this.value[0]
        let scenary = this.value[1]
        let mean = you + scenary
        let aux = you
        you = scenary
        scenary = aux

        windowWidth <= 500 ? this.height = (you * 150) / mean + 10 : this.height = (you * 200) / mean + 10

        if(windowWidth <= 320){
            this.height = (you * 100) / mean + 15
            return
        }
        if(windowHeight <= 565 && windowWidth >= 360){
            this.height = (you * 150) / mean
            return
        }
        if(windowWidth <= 500 && windowWidth > 320){
            this.height = (you * 150) / mean + 10
            return
        }
        if(windowWidth > 500){
            this.height = (you * 180) / mean + 10
            // console.log(this.height)
            return
        }   
        
    }
}
</script>

<style lang="scss" scoped>
    .bar-chart{
        margin: -7px 0;
        min-height: 140px;
        // height: 200px;
        border-radius: 300px;


        svg{
            width: 15px;
            border-radius: 10px;
        }
    }

    .upon_bars{
        // min-height: 100px;
        height: auto;
        margin: 0 !important;
        top: 0;
        min-height: auto;
// }
        
        &:nth-child(1){
            top: 2px;
            position: relative;
        }
//         &:nth-child(2){
//             top: 25px !important;
//             margin: 0;
//         }
        
        svg{
            width: 100px;
        }
    }

@media only screen and (max-width: 600px){
    .upon_bars{
        svg{
            width: 60px;
        }
    }
}
@media only screen and (max-width: 360px){
    .bar-chart{
        // margin: -7px 0;
        // min-height: 100px;
        // height: 200px;

        svg{
            width: 15px;
        }
    }
    .upon_bars{
        svg{
            width: 40px;
        }
    }
}
@media only screen and (min-height: 555px) and (max-height: 552px){
    .bar-chart{
        svg{
            width: 20px;
        }
    }    
    .upon_bars{
        svg{
            width: 50px;
        }
    } 
}
</style>
